import { useQuery, useMutation, useQueryClient } from 'react-query';
import Api from '../../../../../shared/Api';
import { deleteLink } from '../queries/deleteMatterportLink';

const getOrder = (orderId) => {
    return new Api().get(`/views/orders/${orderId}`);
};

export const useOrderData = (orderId) => {
    return useQuery(['get-matterport-order', orderId], () => getOrder(orderId));
};

export const useDeleteLinkData = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteLink, {
        onSuccess: () => {
            queryClient.invalidateQueries('get-matterport-order');
        }
    });
};
